import { createSafeContext } from '@/hooks/createContextStore.hooks';

import type { ApiToolCallModel } from '@littlebird/sdk';

export type ReasoningStepContextType = {
  isOpen: boolean;
  last: boolean;
  isHovered: boolean;
  isNew: boolean;
  isActive: boolean;
  isLiveTodo: boolean;
  canExpand: boolean;
  callCount: number;
  toolCall?: ApiToolCallModel;
  /** Stable id of the reasoning step (message id + modality index); lets a card key
   * per-step state that outlives the tool call record. */
  stepId?: string;
  setIsHovered: (isHovered: boolean) => void;
  setIsOpen: (isOpen: boolean) => void;
};

export const [ReasoningStepContextProvider, useReasoningStepContext] =
  createSafeContext<ReasoningStepContextType>(
    'ReasoningStepContext must be used within a ReasoningStepContextProvider'
  );
